var React = require('react');

function HideMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-264.702 -36.978)"},[React.createElement("g",{"transform":"translate(-490.234 -483.165)","key":0},React.createElement("g",{"transform":"translate(755.436 520.643)"},React.createElement("rect",{"width":"32.798","height":"32.798","strokeWidth":"1","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","fill":"none"}))),React.createElement("text",{"transform":"translate(281 61)","fontSize":"22","fontFamily":"LucidaGrande, Lucida Grande","key":1},React.createElement("tspan",{"x":"-11","y":"0"},"→"))]));
}

HideMenu.defaultProps = {"width":"33.798","height":"33.798","viewBox":"0 0 33.798 33.798"};

module.exports = HideMenu;

HideMenu.default = HideMenu;
